import type { JSX } from 'react';

import AddBoxIcon from '@mui/icons-material/AddBox';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';

/* ----------------------------------
   Types
---------------------------------- */

interface AddTaxNumberButtonProps {
  disabled?: boolean;
  onClick: () => void;
  t: (key: string) => string;
}

/* ----------------------------------
   Component
---------------------------------- */

const AddTaxNumberButton = ({
  disabled,
  onClick,
  t
}: AddTaxNumberButtonProps): JSX.Element => (
  <Box
    display="inline-flex"
    alignSelf="flex-start"
    sx={{ mb: 2 }}
  >
    <Button
      size="medium"
      variant="text"
      color="primary"
      disabled={disabled}
      startIcon={
        <AddBoxIcon
          titleAccess="Add Tax Number"
          sx={theme => ({
            color: '#00843D',
            transition: 'color 0.2s',
            '.MuiButton-root:hover &': {
              color: theme.palette.success
                ? theme.palette.success.dark
                : '#03441F'
            },
            '.Mui-disabled &': {
              color: '#BDBDBD'
            }
          })}
        />
      }
      onClick={onClick}
      sx={{ padding: '0px 16px' }}
    >
      {t('buttons.addMore')}
    </Button>
  </Box>
);

export default AddTaxNumberButton;